var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.list.length > 0
      ? _c(
          "div",
          { staticClass: "product-list" },
          _vm._l(_vm.list, function(item, index) {
            return _c("div", { key: index }, [
              item.U_UploadedShow == 1
                ? _c("div", { staticClass: "flex product-list-header" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.U_UploadedShow == 1,
                            expression: "item.U_UploadedShow==1"
                          }
                        ],
                        staticClass: "flex center"
                      },
                      [
                        _c("img", {
                          staticClass: "camera",
                          attrs: {
                            src: require("@/assets/img/camera.png"),
                            alt: ""
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "plan-noSuccess",
                          on: {
                            click: function($event) {
                              return _vm.lookProduction(
                                item.U_CampMemberId,
                                item.reviewUserId
                              )
                            }
                          }
                        },
                        [_vm._v("查看作品")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "product-list-content" }, [
                _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    item.U_RangeTime
                      ? _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("活动日期")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text OF" },
                            [_vm._v(_vm._s(item.U_RangeTime || ""))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.campTypeName
                      ? _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("活动类型")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text OF" },
                            [_vm._v(_vm._s(item.campTypeName || ""))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.campName
                      ? _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("活动名称")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text OF" },
                            [_vm._v(_vm._s(item.campName || ""))]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "joinActivity" }, [
      _c("div", { staticClass: "basic-information-title" }, [
        _vm._v("参与活动")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "redactImg" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-330ed2e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330ed2e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/joinActivity.vue
// module id = null
// module chunks = 